import { ApiClientImplementation } from 'infra/api-client/api-client'
import { PrepareApiRequestDecorator } from 'main/decorators/prepare-api-request-decorator/prepare-api-request-decorator'
import { makeLocalStorageAdapter } from 'main/factories/cache/local-storage-adapter-factory'
import EligibilityService from 'presentation/contexts/services/eligibility-service'
import { ApiRepository } from 'repository/api-repository'
import { EligibilityRepository } from 'repository/repositories/eligibility/eligibility-repository'
import { RemoteEligibilityCheck } from 'service/usecases/eligibility-check/remote-eligibility-check'

export default function makeEligibilityService() {
  const apiRepository = new PrepareApiRequestDecorator(
    makeLocalStorageAdapter(),
    new ApiRepository(new ApiClientImplementation())
  )

  const eligibilityRepository = new EligibilityRepository(apiRepository)

  const eligibilityCheck = new RemoteEligibilityCheck(eligibilityRepository)

  return new EligibilityService({
    eligibilityCheck
  })
}
